var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87402 10.915C4.02344 11.082 4.25195 11.0732 4.41016 10.9062C6.55469 8.63867 9.42871 7.41699 12.6367 7.41699C15.8535 7.41699 18.7451 8.62109 20.8721 10.915C21.0215 11.0732 21.2412 11.0732 21.3994 10.9062L22.542 9.76367C22.6826 9.61426 22.6826 9.42969 22.5684 9.28906C20.5117 6.7666 16.627 4.93848 12.6367 4.93848C8.6377 4.93848 4.74414 6.75781 2.69629 9.28906C2.58203 9.42969 2.59082 9.61426 2.72266 9.76367L3.87402 10.915ZM7.52148 14.5889C7.68848 14.7559 7.89941 14.7383 8.06641 14.5625C9.13867 13.3848 10.8877 12.541 12.6367 12.5586C14.3945 12.541 16.1348 13.4023 17.2246 14.5801C17.3828 14.7471 17.585 14.7471 17.7432 14.5889L19.0439 13.2969C19.1846 13.165 19.1934 12.9893 19.0703 12.8398C17.7695 11.2314 15.2998 10.0625 12.6367 10.0625C9.96484 10.0625 7.50391 11.2402 6.19434 12.8398C6.08008 12.9893 6.08887 13.1562 6.2207 13.2969L7.52148 14.5889ZM12.6367 19.3877C12.8037 19.3877 12.9531 19.2998 13.2871 18.9922L15.3965 16.9531C15.5195 16.8389 15.5459 16.6719 15.4316 16.5225C14.8955 15.8193 13.8145 15.2041 12.6367 15.2041C11.4326 15.2041 10.3428 15.8369 9.81543 16.5576C9.71875 16.6982 9.75391 16.8389 9.87695 16.9531L11.9863 18.9922C12.3115 19.2998 12.4609 19.3877 12.6367 19.3877Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.deb1468ebbb3cb2621e29bb97b94b0a1.svg";
export { ForwardRef as ReactComponent };